export const Actions = {
  GET_USER_PREFERENCES: "GET_USER_PREFERENCES",
  GET_USER_PREFERENCES_SUCCEEDED: "GET_USER_PREFERENCES_SUCCEEDED",
  GET_USER_PREFERENCES_FAILED: "GET_USER_PREFERENCES_FAILED",
  UPDATE_USER_PREFERENCES: "UPDATE_USER_PREFERENCES",
  UPDATE_USER_PREFERENCES_SUCCEEDED: "UPDATE_USER_PREFERENCES_SUCCEEDED",
  UPDATE_USER_PREFERENCES_FAILED: "UPDATE_USER_PREFERENCES_FAILED",
  CLEAR_USER_PREFERENCES_OPERATION_RESULT: "CLEAR_USER_PREFERENCES_OPERATION_RESULT",
};

export default Actions;
